<!-- 書類の使用頻度のサンプル datasetsとかlabels入れたら表示できる-->
<script>
import { Bar } from "vue-chartjs";
export default {
  extends: Bar,
  name: "UserRejectionRate",
  type: "bar",
  // データを分割表示するためのprops
  props: {indexMin: String, indexMax: String, default: () => {return {indexMin: "", indexMax: ""}}},
  data() {
    return {
      data: {
        datasets: [
          {
            label: "社員別却下率(%)",
            data: [10, 20, 30, 10, 50],
            backgroundColor: "#ff9896",
          },
        ],
        labels: ["user111", "user2", "user3", "user4", "user5"],
      },
      options: {
        scales: {
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "ユーザ",
              },
               ticks: {
                autoSkip: true,
                min: "",
                max: "",
               }
            },
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                autoSkip: true,
                max: 100,
                stepSize: 10,
              },
            },
          ],
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  computed: {
    userRejectionRateList: function () {
      return this.$store.getters["domain/userRejectionRateList"];
    },
  },
  watch: {
    userRejectionRateList(val) {
      if (val) {
        this.overwriteGraphData(val);
      }
      this.renderChart(this.data, this.options);
    },
    indexMin (val) {
      this.$set(this.options.scales.xAxes[0].ticks, "min", val || "");
      this.renderChart(this.data, this.options);
    },
    indexMax (val) {
      this.$set(this.options.scales.xAxes[0].ticks, "max", val || "");
      this.renderChart(this.data, this.options);
    }
  },
  mounted() {
    const val = this.$store.getters["domain/userRejectionRateList"];
    this.overwriteGraphData(val);
    this.renderChart(this.data, this.options);
  },
  methods: {
    overwriteGraphData: function (val) {
      let userId = [];
      let rejectinRate = [];
      for (let i = 0; i < val.length; i++) {
        const data = val[i];
        userId.push(data.user_id);
        rejectinRate.push(data.rejection_rate);
      }
      this.$set(this.data.datasets[0], "data", rejectinRate);
      this.$set(this.data, "labels", userId);
    },
  },
};
</script>
